import { api } from './client';
import { config } from '../config';
import { Tutorials, resolveMediaUrl as resolveAgainst } from './schemasTutorials';

const resolveMediaUrl = (url: string | null | undefined) => resolveAgainst(url, config.apiUrl);

/* ---------- Tutorials (SPEC decision 20) ---------- */

const resolveText = <T>(v: T): T => (v && typeof v === 'object' ? (Object.fromEntries(Object.entries(v).map(([k, s]) => [k, typeof s === 'string' ? resolveMediaUrl(s) : s])) as T) : typeof v === 'string' ? (resolveMediaUrl(v) as T) : v);

/** `GET /tutorials`: the lessons the caller may watch (filtered by audience on the server), media signed until `mediaExpiresAt`. */
export async function getTutorials(): Promise<Tutorials> {
  const t = await api('GET', '/tutorials', { schema: Tutorials });
  return {
    ...t,
    lessons: t.lessons.map((l) => ({
      ...l,
      steps: l.steps.map((s) => ({ ...s, image: resolveMediaUrl(s.image), audio: resolveText(s.audio) })),
      walkthrough: l.walkthrough ? { video: resolveMediaUrl(l.walkthrough.video), audio: resolveText(l.walkthrough.audio) } : l.walkthrough,
    })),
  };
}
